
export const sFechaPublicacion = '2026-10-26T14:49:19.9466118-06:00';
export const sVersion = 'vAI0.1.610261449';
            